import { render, staticRenderFns } from "./MicroLife.vue?vue&type=template&id=32791b7f"
import script from "./MicroLife.js?vue&type=script&lang=js&external"
export * from "./MicroLife.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports